/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */
import type {
  ClientGroup
} from '../../model';

import { customFetch } from '../../../liftApiMutator';

export type clientsListResponse200 = {
  data: ClientGroup[]
  status: 200
}

export type clientsListResponseSuccess = (clientsListResponse200) & {
  headers: Headers;
};
;

export type clientsListResponse = (clientsListResponseSuccess)

export const getClientsListUrl = () => {




  return `/api/v1/clients/`
}

/**
 * Read-only access to ClientGroups.
 */
export const clientsList = async ( options?: RequestInit): Promise<clientsListResponse> => {

  return customFetch<clientsListResponse>(getClientsListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}


export type clientsRetrieveResponse200 = {
  data: ClientGroup
  status: 200
}

export type clientsRetrieveResponseSuccess = (clientsRetrieveResponse200) & {
  headers: Headers;
};
;

export type clientsRetrieveResponse = (clientsRetrieveResponseSuccess)

export const getClientsRetrieveUrl = (id: string,) => {




  return `/api/v1/clients/${id}/`
}

/**
 * Read-only access to ClientGroups.
 */
export const clientsRetrieve = async (id: string, options?: RequestInit): Promise<clientsRetrieveResponse> => {

  return customFetch<clientsRetrieveResponse>(getClientsRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}


export type clientsAccessibleClientGroupsListResponse200 = {
  data: ClientGroup[]
  status: 200
}

export type clientsAccessibleClientGroupsListResponseSuccess = (clientsAccessibleClientGroupsListResponse200) & {
  headers: Headers;
};
;

export type clientsAccessibleClientGroupsListResponse = (clientsAccessibleClientGroupsListResponseSuccess)

export const getClientsAccessibleClientGroupsListUrl = () => {




  return `/api/v1/clients/accessible-client-groups/`
}

/**
 * Get all client groups that the authenticated consultant can access
 *
 * Only consultant users can access this endpoint.
 */
export const clientsAccessibleClientGroupsList = async ( options?: RequestInit): Promise<clientsAccessibleClientGroupsListResponse> => {

  return customFetch<clientsAccessibleClientGroupsListResponse>(getClientsAccessibleClientGroupsListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}


